var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#60646c",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3335 10.0007c0-5.41672 1.66666-6.66672 7.5-6.66672 5.8333 0 7.5 1.25 7.5 6.66672 0 5.4166-1.6667 6.6666-7.5 6.6666-.4411 0-.85737-.0083-1.25-.0255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.1665 14.1667h1.66667m0 0h1.66667m-1.66667 0v1.6666m0-1.6666v-1.6667m4.16667 1.6667c0 2.3012-1.86548 4.1666-4.16667 4.1666s-4.16667-1.8654-4.16667-4.1666 1.86548-4.1667 4.16667-4.1667 4.16667 1.8655 4.16667 4.1667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9165 13.334c-1.6667 0-4.1667 0-4.1667-2.9167 0-2.91665 2.5-2.91665 4.1667-2.91665"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2502,
    cy: 10.4167,
    fill: "#60646c",
    r: 0.416667
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet_add.33ef084ee4d99da785e85a2fa09153f9.svg";
export { ForwardRef as ReactComponent };